import { useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import type { GridColDef } from "@mui/x-data-grid";
import { LATEST } from "@/api/report/_models/Report";
import { getReceiptReport } from "@/api/report/getReceiptReport";
import { getReceiptReportList } from "@/api/report/getReceiptReportList";
import { ReportView } from "./ReportView";
import { ReportSelector } from "./ReportSelector";

const COLUMNS: GridColDef[] = [
  { field: "date", headerName: "Date", width: 120 },
  { field: "item", headerName: "Item", width: 180 },
  { field: "expectedQuantity", headerName: "Expected", type: "number", width: 110 },
  { field: "receivedQuantity", headerName: "Received", type: "number", width: 110 },
  { field: "container", headerName: "Container", flex: 1, minWidth: 160 },
];

export const ReceiptReport = () => {
  const [selected, setSelected] = useState(LATEST);
  const listQuery = getReceiptReportList.useQuery();
  const reportQuery = getReceiptReport.useQuery(selected);
  const rows = reportQuery.data ?? null;

  let error: string | null = null;
  if (reportQuery.isError) {
    error = JSON.stringify(reportQuery.error);
  }

  const selector = (
    <ReportSelector
      id="receipt-report"
      files={listQuery.data ?? null}
      value={selected}
      onChange={setSelected}
    />
  );

  return (
    <ReportView
      title="Receipt report"
      loading={reportQuery.isFetching}
      error={error}
      count={rows?.length ?? null}
      action={selector}
    >
      {rows && (
        <Box sx={{ height: "calc(100vh - 220px)", width: "100%" }}>
          <DataGrid
            rows={rows.map((row, i) => ({ id: i, ...row }))}
            columns={COLUMNS}
            density="compact"
            pageSizeOptions={[25, 50, 100]}
            initialState={{
              pagination: { paginationModel: { pageSize: 50 } },
            }}
            disableRowSelectionOnClick
          />
        </Box>
      )}
    </ReportView>
  );
};
